import { gql } from 'graphql.macro';
import { oauthAppFieldsFragment } from 'apollo/fragments/oauth-app';

export const createOAuthAppTemplate = gql`
    mutation createOAuthApp($input: CreateOAuthAppInput!) {
        createOAuthApp(input: $input) {
            app {
                ...oauthAppFields
            }
            clientSecret
        }
    }
    ${oauthAppFieldsFragment}
`;

export const updateOAuthAppTemplate = gql`
    mutation updateOAuthApp($id: MongoDbObjectId!, $input: UpdateOAuthAppInput!) {
        updateOAuthApp(id: $id, input: $input) {
            ...oauthAppFields
        }
    }
    ${oauthAppFieldsFragment}
`;

export const rotateOAuthAppSecretTemplate = gql`
    mutation rotateOAuthAppSecret($id: MongoDbObjectId!) {
        rotateOAuthAppSecret(id: $id) {
            app {
                ...oauthAppFields
            }
            clientSecret
        }
    }
    ${oauthAppFieldsFragment}
`;

export const setOAuthAppStatusTemplate = gql`
    mutation setOAuthAppStatus($id: MongoDbObjectId!, $status: OAuthAppStatus!) {
        setOAuthAppStatus(id: $id, status: $status) {
            ...oauthAppFields
        }
    }
    ${oauthAppFieldsFragment}
`;

export const deleteOAuthAppTemplate = gql`
    mutation deleteOAuthApp($id: MongoDbObjectId!) {
        deleteOAuthApp(id: $id)
    }
`;
